module.exports = __webpack_public_path__ + "img/undraw_programming_2svr.7fb94a5b.svg";